import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./style/dialog.scss?vue&type=style&index=0&id=5020ae9e&lang=scss&scoped=true&external"
import "./index.vue?vue&type=style&index=1&id=5020ae9e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5020ae9e"]])

export default __exports__